export const AZURE_AD = {
  clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
  tenantId: import.meta.env.VITE_AZURE_AD_TENANT_ID,
  authority: import.meta.env.VITE_AZURE_AD_AUTHORITY,
};

export const BACKEND_API = {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  prefix: import.meta.env.VITE_API_PREFIX,
};

export const APPLICATION_ID = 'call-summarization-app';

export const STORAGE_BASE = `s3://podium-ia-call-summarization-app-documents-${process.env.ENTERPRISE_NAME}-${process.env.NODE_ENV}`;

export const FEEDBACK_SWITCH_ENABLED = import.meta.env.VITE_FEEDBACK_SWITCH_ENABLED === 'true';

export const CONFIG = {
  appVersion: '3.0.0',
  assetsDir: '',
  auth: {
    method: 'msal',
    redirectPath: '/',
  },
};
